import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Modal } from 'antd';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { hideModal } from '../store/actions';
import { Icon } from 'dlweb-components';
import Modals from '../components/modals';

const ModalRoot = (props) => {

  const modalRef = useRef(null);

  let responsiveProps = {};

  const [x, setX] = useState('100px');
  const [y, setY] = useState('100px');
  const [height, setHeight] = useState(`${window.innerHeight *.8}px`);
  const [width, setWidth] = useState(`${window.innerWidth *.8}px`);
  const [visible, setVisible] = useState(false);

  const [maxWidth] = useState(1800);
  const [minWidth] = useState(900);

  const [maxHeight] = useState(1100);
  const [minHeight] = useState(minWidth * .64);

  const onWindowResize = useCallback((e) => {
     
    const newWidth = `${window.innerWidth - 150}`
    const newHeight = `${(window.innerHeight - 75)}`

    const ratioWidth = (newHeight / .64)
    const ratioHeight = (newWidth * .64);

    let xPosition = (window.innerWidth - _.clamp(newWidth, minWidth, maxWidth)) / 2;
    let yPosition = (window.innerHeight - _.clamp(ratioHeight, minHeight, maxHeight)) / 2;

    if((window.innerHeight - ratioHeight) < 125) {
      setWidth(`${ratioWidth}px`);
      setHeight(`${newHeight}px`);

      xPosition = (window.innerWidth - _.clamp(ratioWidth, minWidth, maxWidth)) / 2;
      yPosition = (window.innerHeight - _.clamp(newHeight, minHeight, maxHeight)) / 2;
    }
    else {
      setWidth(`${newWidth}px`);
      setHeight(`${ratioHeight}px`);

      xPosition = (window.innerWidth - _.clamp(newWidth, minWidth, maxWidth)) / 2;
      yPosition = (window.innerHeight - _.clamp(ratioHeight, minHeight, maxHeight)) / 2;
    }

    setX(xPosition);
    setY(yPosition);
    
  }, [maxHeight, maxWidth, minHeight, minWidth])

  useEffect(() => {
    
    props.modalType !== null ? openModal() : hideModal();

    if(props.modalProps.responsive) {
      onWindowResize();
      window.addEventListener('resize', onWindowResize)
  
      return () => {
        window.removeEventListener('resize', onWindowResize);
      }
    }
  }, [props, onWindowResize])

  const openModal = useCallback(() => {
    setVisible(true);
  }, [])

  const hideModal = useCallback(() => {
    setVisible(false);
  }, [])

  const modalOptions = {
    visible: visible,
    onOk: hideModal, 
    onCancel: hideModal, 
    destroyOnClose: true,
    forceRender: true
  }

  if(props.modalProps.responsive) {
    responsiveProps = {
      width: width,
      bodyStyle: {height: 'calc(100% - 60px'},
      style: {
        top: y,
        left: x,
        position: 'absolute',
        maxWidth: `${maxWidth}px`,
        maxHeight: '1100px',
        height: height, 
        minHeight: minHeight,
        minWidth: minWidth
      }
    }
  }
  else {
    responsiveProps = {}; 
  }

  if (props.modalType === 'ERROR') {
    return (
      <Provider store={props.store}>
        <Modal
          {...modalOptions} 
          cancelButtonProps={{hidden: true}}
          {...props.modalProps}
        >
          <div style={{ display: 'flex'}}>
            <div style={{ width: '50px', color: '#ff4d4f' }}><Icon type="exclamation-circle" /></div>
            <div dangerouslySetInnerHTML={{ __html: props.modalContentProps.content }}></div>
          </div>
        </Modal>
      </Provider>

    )
  }
  else {
    const ModalContents = Modals[props.modalType] || null;

    return (
      <Provider store={props.store}>
        <Modal
          ref={modalRef}
          {...modalOptions}
          {...props.modalProps}
          {...responsiveProps}
        >
          {props.modalType ? <ModalContents hideModal={hideModal} angularScope={props.$rootScope} {...props.modalContentProps} /> : null}
        </Modal>
      </Provider>
    )
  }
}

const mapStateToProps = state => state.modal;
const mapDispatchToProps = { hideModal };

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);